import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { LanguageProvider } from "@/lib/i18n";
import "@/App.css";

import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import Contact from "@/pages/Contact";
import Story from "@/pages/Story";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProperties from "@/pages/admin/AdminProperties";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminStaff from "@/pages/admin/AdminStaff";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/proprieta" element={<Properties />} />
              <Route path="/proprieta/:id" element={<PropertyDetail />} />
              <Route path="/storia" element={<Story />} />
              <Route path="/contatti" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/proprieta" element={<AdminProperties />} />
              <Route path="/admin/prenotazioni" element={<AdminBookings />} />
              <Route path="/admin/calendario" element={<AdminCalendar />} />
              <Route path="/admin/messaggi" element={<AdminMessages />} />
              <Route path="/admin/staff" element={<AdminStaff />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
